'use client';
import { jsx } from 'react/jsx-runtime';
import { noTooltipInternal } from '../icon-button/icon-button-internal.utils.js';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useRequiredI18nProps, getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const FileTileDeleteButton = renderWithRef('FileTileDeleteButton', null, (t, l)=>{
    let u = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('FileDropzone', t, [
        {
            propName: 'accessibleText',
            instructions: getDeprecatedI18nPropMessage(u)
        }
    ]), useRequiredI18nProps(t, [
        'accessibleText'
    ]);
    let { accessibleText: b } = t, a = _object_without_properties(t, [
        "accessibleText"
    ]), f = b;
    return u && !b && (f = u.t('file-tile-delete-button.accessible-text-for-icon')), jsx(IconButton, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        className: 'swan-file-tile-delete-button',
        skin: "destructive-secondary",
        "aria-label": f,
        ref: l
    }, a), {
        tooltip: ""
    }), noTooltipInternal), {
        children: jsx(Icon, {
            iconType: "delete"
        })
    }));
});

export { FileTileDeleteButton };
